import api from "./axios";

export interface SavingsAccount {
  id: number;
  partyId: number;
  currency: string;
  inscriptionFeeAmount: string;
  subscriptionSource: "direct" | "credit_conversion";
  sourceCreditLotId?: number;
  balance: string;
  createdAt: string;
}

export interface SavingsTransaction {
  id: number;
  accountId: number;
  nature: "deposit" | "withdraw";
  amount: string;
  quantity: number;
  totalAmount: string;
  status: "draft" | "recorded";
  appliedToInvoiceId?: number;
  receiptNumber?: string;
  reversalOfTransactionId?: number;
  agentId?: number;
  responsibleAgentId?: number;
  recordedAt?: string;
  createdAt: string;
}

export const savingsApi = {
  subscribe: (partyId: number, responsibleAgentId?: number) =>
    api.post<SavingsAccount>("/savings/subscribe", { partyId, responsibleAgentId }),
  getAccountByParty: (partyId: number) => api.get<SavingsAccount>(`/savings/party/${partyId}`),
  listTransactions: (accountId: number) => api.get<SavingsTransaction[]>(`/savings/${accountId}/transactions`),
  deposit: (accountId: number, amount: number, quantity?: number, responsibleAgentId?: number) =>
    api.post<SavingsTransaction>(`/savings/${accountId}/deposits`, { amount, quantity, responsibleAgentId }),
  withdraw: (accountId: number, amount: number, quantity?: number, responsibleAgentId?: number) =>
    api.post<SavingsTransaction>(`/savings/${accountId}/withdrawals`, { amount, quantity, responsibleAgentId }),
  reverse: (transactionId: number, reason: string) =>
    api.post<SavingsTransaction>(`/savings/transactions/${transactionId}/reverse`, { reason }),
  reassignTransactionResponsibleAgent: (transactionId: number, responsibleAgentId: number, reason?: string) =>
    api.patch<SavingsTransaction>(`/savings/transactions/${transactionId}/responsible-agent`, {
      responsibleAgentId,
      reason,
    }),
  triggerConversion: () => api.post<{ converted: number; heldForReview: number }>("/savings/convert-expired-credit"),
  convertCredit: (partyId: number, amount: number, responsibleAgentId?: number) =>
    api.post<SavingsAccount>("/savings/convert-credit", { partyId, amount, responsibleAgentId }),
};
